import { Box, Button, Paper, Stack, Typography } from '@mui/material';
import { PLANS } from './tokens';
import { HEIGHT_BELOW_BARS } from '../../core/bannerOffset';

export const PLANS_EMPTY_STATE_COPY = {
  eyebrow: 'Student Action Plans',
  title: 'No Plans Generated Yet',
  body: 'Click the button below to generate your first set of student action plans.',
  bodyWithoutAction: 'Student Action Plans will appear here once they are generated.',
  buttonLabel: 'Generate Plans',
} as const;

export function PlansEmptyState({ onGenerate }: { onGenerate?: () => void }) {
  const { eyebrow, title, buttonLabel } = PLANS_EMPTY_STATE_COPY;
  const body = onGenerate ? PLANS_EMPTY_STATE_COPY.body : PLANS_EMPTY_STATE_COPY.bodyWithoutAction;
  return (
    <Box
      sx={{
        minHeight: `calc(${HEIGHT_BELOW_BARS} - 64px)`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        pb: 5,
      }}
    >
      <Paper
        data-testid="plans-empty-card"
        elevation={1}
        sx={{
          width: 480,
          p: 3,
          borderRadius: '16px',
          bgcolor: PLANS.cardBg,
          boxShadow: PLANS.cardShadow,
        }}
      >
        <Stack spacing={3}>
          <Stack spacing={1}>
            <Stack spacing={0.5}>
              <Typography
                sx={{
                  fontFamily: PLANS.font,
                  fontSize: 16,
                  fontWeight: 700,
                  lineHeight: '24px',
                  color: PLANS.muted,
                }}
              >
                {eyebrow}
              </Typography>
              <Typography
                component="h2"
                sx={{
                  fontFamily: PLANS.font,
                  fontSize: 24,
                  fontWeight: 600,
                  lineHeight: '32px',
                  color: PLANS.ink,
                }}
              >
                {title}
              </Typography>
            </Stack>
            <Typography
              sx={{
                fontFamily: PLANS.font,
                fontSize: 16,
                fontWeight: 500,
                lineHeight: '24px',
                color: PLANS.muted,
              }}
            >
              {body}
            </Typography>
          </Stack>
          {onGenerate && (
            <Box>
              <Button
              variant="contained"
              onClick={onGenerate}
              sx={{
                bgcolor: PLANS.buttonBg,
                color: '#FFFFFF',
                height: 40,
                px: 2,
                borderRadius: '8px',
                fontFamily: PLANS.font,
                fontSize: 16,
                fontWeight: 600,
                letterSpacing: '0.0313em',
                lineHeight: '40px',
                textTransform: 'none',
                boxShadow: 'none',
                '&:hover': { bgcolor: PLANS.buttonHoverBg, boxShadow: 'none' },
              }}
            >
              {buttonLabel}
              </Button>
            </Box>
          )}
        </Stack>
      </Paper>
    </Box>
  );
}
